import { IMAGE } from '../elements/assets'

export const RELEASE_TIMELINE = `
...on releaseTimeline_Entry {
  id
  typeHandle

  heading {
    html
  }
  description
  productUpdates {
    ... on productUpdate_Entry {
      id
      postDate
      title
      description
      ${ IMAGE }
      externalLink {
        url
      }
    }
  }
}
`